enum NewsDialogFields {
	ENABLED = "enabled",
	URL = "url",
	INTERVAL = "interval"
}

export default NewsDialogFields;